import {
  ContextMenu,
  ContextMenuItem,
  ContextMenuSub,
  ContextMenuSubContent,
  ContextMenuSubTrigger,
} from "@/components/ui";
import type { MatterLitigationDateType } from "@/lib/types";
import { copyToClipboard } from "@/lib/utils/copyToClipboard";
import { Clipboard, Copy } from "lucide-react";
import type { ReactNode } from "react";

type MatterLitigationDateTypeRowContextMenuProps = {
  canDelete: boolean;
  canEdit: boolean;
  dateType: MatterLitigationDateType;
  onDelete: () => void;
  onEdit: () => void;
  trigger: ReactNode;
};

export function MatterLitigationDateTypeRowContextMenu({
  canDelete,
  canEdit,
  dateType,
  onDelete,
  onEdit,
  trigger,
}: MatterLitigationDateTypeRowContextMenuProps) {
  return (
    <ContextMenu
      entityName="litigation date type"
      open={canEdit ? { onSelect: onEdit } : false}
      delete={canDelete ? { onSelect: onDelete } : false}
      trigger={trigger}
    >
      <ContextMenuSub>
        <ContextMenuSubTrigger>
          <Copy />
          Copy
        </ContextMenuSubTrigger>
        <ContextMenuSubContent>
          <ContextMenuItem
            onSelect={() => {
              void copyToClipboard(
                dateType.label,
                "Litigation date type label",
              );
            }}
          >
            <Clipboard />
            Copy type label
          </ContextMenuItem>
          <ContextMenuItem
            onSelect={() => {
              void copyToClipboard(
                dateType.category,
                "Litigation date category",
              );
            }}
          >
            <Clipboard />
            Copy category
          </ContextMenuItem>
          <ContextMenuItem
            disabled={!dateType.description}
            onSelect={() => {
              void copyToClipboard(dateType.description ?? "", "Description");
            }}
          >
            <Clipboard />
            Copy description
          </ContextMenuItem>
        </ContextMenuSubContent>
      </ContextMenuSub>
    </ContextMenu>
  );
}
